import React, { useMemo } from 'react';
import styles from './RecordCompareRecordMetaData.module.scss';
import I18n from '../../../I18n/I18n/I18n';
export default function RecordMetaData(_ref) {
  var allowSharing = _ref.allowSharing,
    originalSource = _ref.originalSource,
    lastSavedTime = _ref.lastSavedTime,
    createdTime = _ref.createdTime,
    cardView = _ref.cardView;
  var allowSharingI18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.metaData.sharing',
      values: {
        value: allowSharing
      }
    };
  }, [allowSharing]);
  var originalSourceI18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.metaData.original-source',
      values: {
        value: originalSource
      }
    };
  }, [originalSource]);
  var createdTimeI18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.metaData.created',
      values: {
        value: new Date(createdTime)
      }
    };
  }, [createdTime]);
  var lastSavedTimeI18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.metaData.last-saved',
      values: {
        value: new Date(lastSavedTime)
      }
    };
  }, [lastSavedTime]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['container']).concat(cardView ? " ".concat(styles['card-view']) : '')
  }, allowSharing && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: allowSharingI18n
  })), originalSource && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: originalSourceI18n
  })), createdTime && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: createdTimeI18n
  })), lastSavedTime && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: lastSavedTimeI18n
  })));
}